import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertAudioUI from './insertaudioui';

export default class InsertAudio extends Plugin {
  static get pluginName() {
    return 'InsertAudio';
  }

  static get requires() {
    return [ InsertAudioUI];
  }
}
